import { render, staticRenderFns } from "./TurnProductivity.vue?vue&type=template&id=45af393c"
import script from "./TurnProductivity.vue?vue&type=script&lang=js"
export * from "./TurnProductivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports